function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.5 4C6.818 4 1.966 7.525 0 12.5 1.966 17.475 6.818 21 12.5 21s10.534-3.525 12.5-8.5C23.034 7.525 18.182 4 12.5 4zm0 14.167c-3.136 0-5.682-2.539-5.682-5.667 0-3.128 2.546-5.667 5.682-5.667 3.136 0 5.682 2.539 5.682 5.667 0 3.128-2.546 5.667-5.682 5.667zm0-9.067a3.4 3.4 0 100 6.8 3.4 3.4 0 100-6.8z"
});

function SvgVisibilityShow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25"
  }, props), _ref);
}

export default SvgVisibilityShow;